module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullScreenLoader",
    class: {
      active: _vm.active
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadingCard"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "loaderHolder"
  }, [_c('div', {
    staticClass: "loader"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3133e198", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3133e198"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/fullScreenLoader/FullScreenLoader.vue
// module id = 2355
// module chunks = 0